import { interfacesMenus } from "@/components/interfaces-menus";

const getDefaultState = () => {
    return {
        interfacesMenus: [],
        activeInterface: "",
        activeInterfaceMenu: {}
    }
}

export const state = getDefaultState();

export const getters = {
    getAllInterfaceMenus: (state) => state.interfacesMenus,
    getActiveInterface: (state) => state.activeInterface,
    getActiveInterfaceMenu: (state) => state.activeInterfaceMenu
}

export const actions = {
    initMenu({ commit }) {
        commit('INIT_MENU')
    },
    clearMenuState({ commit }){
        commit('CLEAR_MENU_STATE')
    },
    setActiveInterfaceMenu({ commit }, interf) {
        commit('SET_ACTIVE_INTERFACE', interf)
        commit('SET_ACTIVE_INTERFACE_MENU', interf)
    }
}

export const mutations = {
    INIT_MENU: (state) => {
        state.interfacesMenus = interfacesMenus;
        state.activeInterface = localStorage.getItem('activeInterface');
        state.activeInterfaceMenu = interfacesMenus.filter(i => i.interface === localStorage.getItem('activeInterface'))[0];
    },
    CLEAR_MENU_STATE: (state) => {
        state.interfacesMenus = getDefaultState().interfacesMenus;
        state.activeInterface = getDefaultState().activeInterface;
        state.activeInterfaceMenu = getDefaultState().activeInterfaceMenu;
    },
    SET_ACTIVE_INTERFACE: (state, interf) => {
        state.activeInterface = interf
        localStorage.setItem('activeInterface', interf)
    },
    SET_ACTIVE_INTERFACE_MENU: (state, interf) => {
        state.activeInterfaceMenu = state.interfacesMenus.filter(i => i.interface === interf)[0]
    }
}